import React from "react";
import Navbar from "../User/Navbar";
import Hero from "./SubComponent/Hero";
import Stats from "./SubComponent/Stats";
import Cta from "./SubComponent/CTA";
import Team from "./SubComponent/Team";
import Services from "./SubComponent/Service";
import Blogs from "./SubComponent/Blog";
import Testimonials from "./SubComponent/Testimonial";
import Footer from "./SubComponent/Footer";
import Contact from "./SubComponent/Contact";
import Animation from "../../Static/gobal";
import Map from "./SubComponent/Map";
import Category from "./SubComponent/Category";

function Home() {
  return (
    <>
      <Navbar />

      <section id="hero">
        <Hero />
      </section>
      <section id="stats">
        <Animation>
          <Stats />
        </Animation>
      </section>
      <section id="cta">
        <Animation>
          <Cta />
        </Animation>
      </section>
      <section id="team">
        <Animation>
          <Team />
        </Animation>
      </section>
      <section id="blogs">
        <Animation>
          <Blogs />
        </Animation>
      </section>
      <section id="services">
        <Animation>
          <Services />
        </Animation>
      </section>
      <section id="category">
        <Animation>
          <Category />
        </Animation>
      </section>
      <section id="testimonials">
        <Animation>
          <Testimonials />
        </Animation>
      </section>
      <section id="contact">
        <Animation>
          <Contact />
        </Animation>
      </section>
      <Map />
      <Footer />
    </>
  );
}

export default Home;
